import { PROJECTSTATUS_SUCCESS, PROJECTSTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const projectStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROJECTSTATUS_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case PROJECTSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default projectStatusReducer;
